<app-menu>
    <div class="grid-header">
      <div class="grid-title">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-landmark"></i>&nbsp;PCES TRANSACTION PENDING List -->
        <button (click)="pcesClientLists()" style="background-color: rgb(244, 240, 245); color: black;" mat-raised-button color="primary">PCES CLIENT List</button><br><br>
        <mat-card-content>
          <div [formGroup]="search_client" style="display: flex ; justify-content: space-start; flex-wrap: wrap;">
              <span style="flex-basis: 100%; display: flex; justify-content: space-between;">
                  <mat-form-field style="width: 100%;">
                      <mat-label>Client Name:</mat-label>
                      <input matInput formControlName="clientname" placeholder="Start Typing...">
                  </mat-form-field>&nbsp;&nbsp;
                  <mat-form-field style="width: 100%;">
                    <mat-label>Factoring For:</mat-label>
                    <input matInput formControlName="factoringfor" placeholder="Start Typing...">
                </mat-form-field>                  
              </span>
          </div>
          <div style="width: 50%; display: flex; justify-content: flex-start; gap: 20px">
              <!-- Search Button -->
              <button (click)="search()" mat-raised-button color="primary" style="background-color:rgb(21, 4, 117); font-size: 12px;">
                <i class="fa-solid fa-magnifying-glass"></i>
                <span class="text">Search</span>
              </button>
            
              <!-- Reset Button -->
              <button mat-raised-button (click)="resetFilter()"  mat-raised-button color="primary" style="background-color:rgb(21, 4, 117); font-size: 12px;">
                <i class="fas fa-undo"></i>
                <span class="text">Reset</span>
              </button>
          </div>              
        </mat-card-content>           
      </div>        
      <div class="toolbar-actions">
        <button (click)="DeleteAllTransaction()" style="background-color: rgb(125, 11, 160); " mat-raised-button color="primary">
          <i style="font-size: 15px;" class="fa-solid fa-trash"></i>&nbsp;Delete All Transaction
        </button><br><br><br>
        <span class="select-and-button">
          <span>
              <b>Total Transaction Amount: </b>${{total_amount}}<br>
              <b>No of Transaction: </b>{{no_of_transactions}}<br>
          </span>
        </span>        
      </div>        
      <div class="toolbar-actions">
        <div class="search-container" style="background-color: rgb(211, 213, 230); ">
          <div class="grid-title"><span style="text-align: center; font-size: 14px;">&nbsp;&nbsp;&nbsp;Create RBC Payment Files</span><br></div>&nbsp;&nbsp;&nbsp;
          <button (click)="createTransactionCDNFile()" style="background-color: rgb(2, 9, 71); " mat-raised-button color="primary">
            <i style="font-size: 15px;" class="fa-solid fa-money-bill"></i>&nbsp;Create CND Transactions
          </button>&nbsp;&nbsp;&nbsp;
          <button (click)="createTransactionUSFile()" style="background-color: rgb(2, 9, 71); " mat-raised-button color="primary">
            <i style="font-size: 15px;" class="fa-solid fas fa-money-bill-alt"></i>&nbsp;Create USD Transactions
          </button><br><br>&nbsp;&nbsp;&nbsp;
          <button (click)="createTransactionCND_USFile()" style="background-color: rgb(2, 9, 71); " mat-raised-button color="primary">
            <i style="font-size: 15px;" class="fa-solid fa-money-bill-wave"></i>&nbsp;Create CND USD Transactions
          </button>&nbsp;&nbsp;&nbsp;
        </div>
      </div>      
    </div>   
    <ag-grid-angular #agGrid
    style="width: 100%; height: 100%;"
    class="ag-theme-alpine"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [animateRows]="true"
    [rowData]="rowData"
    [rowModelType]="'serverSide'"
    [cacheBlockSize]="100"
    (gridReady)="onGridReady($event)"
    [masterDetail]="true" 
    [detailRowHeight]="350"
    >
    </ag-grid-angular>
  </app-menu>
